import { render, staticRenderFns } from "./OnboardingStep2.vue?vue&type=template&id=29bd8506&scoped=true"
import script from "./OnboardingStep2.vue?vue&type=script&lang=js"
export * from "./OnboardingStep2.vue?vue&type=script&lang=js"
import style0 from "./OnboardingStep2.vue?vue&type=style&index=0&id=29bd8506&prod&lang=scss"
import style1 from "./OnboardingStep2.vue?vue&type=style&index=1&id=29bd8506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bd8506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
